import { render, staticRenderFns } from "./AreaMap.vue?vue&type=template&id=4bfab5a0"
import script from "./AreaMap.vue?vue&type=script&lang=ts"
export * from "./AreaMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports